import React from 'react';
import { UploaderConsumer } from '../UploaderContext';
import getAssetsFromMap from './utils/getAssetsFromMap';






function AssetSelector({ assetIds, children }) {
  return (
    <UploaderConsumer>
      {({ assetsMap }) => children(getAssetsFromMap(assetsMap, assetIds))}
    </UploaderConsumer>);

}

export default AssetSelector;